export interface PillarMeta {
  slug: string;
  icon: string;
  image: string;
}

export const PILLAR_ARTICLES: PillarMeta[] = [
  {
    slug: "review",
    icon: "ri-star-line",
    image: "https://readdy.ai/api/search-image?query=Modern%20ecommerce%20review%20concept%20with%20a%20shopping%20cart%20icon%20on%20a%20laptop%20screen%20beside%20a%20folded%20shirt%20and%20five%20rating%20stars%20on%20a%20warm%20cream%20desk%20soft%20natural%20window%20light%20editorial%20minimal%20clean%20composition&width=1600&height=900&seq=article-review&orientation=landscape",
  },
  {
    slug: "shipping",
    icon: "ri-ship-line",
    image: "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20and%20a%20brown%20parcel%20with%20shipping%20labels%20arranged%20beside%20a%20small%20green%20plant%20on%20a%20warm%20beige%20surface%20soft%20daylight%20minimal%20logistics%20concept%20editorial&width=1600&height=900&seq=article-shipping&orientation=landscape",
  },
  {
    slug: "coupon",
    icon: "ri-coupon-line",
    image: "https://readdy.ai/api/search-image?query=Discount%20coupon%20tickets%20and%20a%20small%20gift%20box%20with%20a%20percent%20sign%20tag%20arranged%20on%20a%20soft%20sage%20green%20background%20warm%20minimal%20promotion%20and%20savings%20concept&width=1600&height=900&seq=article-coupon&orientation=landscape",
  },
  {
    slug: "warehouse",
    icon: "ri-building-line",
    image: "https://readdy.ai/api/search-image?query=Rows%20of%20neatly%20organized%20cardboard%20boxes%20on%20warm%20wooden%20warehouse%20shelves%20with%20soft%20lighting%20and%20a%20clipboard%20resting%20in%20front%20minimal%20clean%20logistics%20and%20storage%20concept&width=1600&height=900&seq=article-warehouse&orientation=landscape",
  },
  {
    slug: "legit",
    icon: "ri-shield-check-line",
    image: "https://readdy.ai/api/search-image?query=A%20protective%20shield%20icon%20beside%20a%20smartphone%20and%20a%20credit%20card%20on%20a%20warm%20cream%20surface%20symbolizing%20secure%20and%20safe%20online%20shopping%20soft%20minimal%20editorial%20composition&width=1600&height=900&seq=article-legit&orientation=landscape",
  },
  {
    slug: "qc",
    icon: "ri-search-eye-line",
    image: "https://readdy.ai/api/search-image?query=A%20magnifying%20glass%20over%20a%20folded%20garment%20with%20a%20quality%20checklist%20on%20a%20clipboard%20warm%20minimal%20product%20inspection%20and%20quality%20control%20concept&width=1600&height=900&seq=article-qc&orientation=landscape",
  },
  {
    slug: "sellers",
    icon: "ri-store-2-line",
    image: "https://readdy.ai/api/search-image?query=A%20small%20storefront%20illustration%20with%20product%20cards%20and%20rating%20stars%20floating%20on%20a%20warm%20beige%20background%20minimal%20seller%20and%20shop%20concept%20editorial&width=1600&height=900&seq=article-sellers&orientation=landscape",
  },
  {
    slug: "products",
    icon: "ri-shopping-bag-line",
    image: "https://readdy.ai/api/search-image?query=An%20organized%20flat%20lay%20of%20folded%20clothing%20a%20pair%20of%20sneakers%20and%20a%20leather%20handbag%20arranged%20neatly%20on%20a%20warm%20cream%20background%20minimal%20product%20assortment%20editorial&width=1600&height=900&seq=article-products&orientation=landscape",
  },
  {
    slug: "payment",
    icon: "ri-bank-card-line",
    image: "https://readdy.ai/api/search-image?query=A%20credit%20card%20a%20leather%20wallet%20and%20a%20paper%20receipt%20arranged%20on%20a%20warm%20neutral%20desk%20with%20soft%20light%20minimal%20online%20payment%20concept%20editorial&width=1600&height=900&seq=article-payment&orientation=landscape",
  },
  {
    slug: "alternatives",
    icon: "ri-arrow-left-right-line",
    image: "https://readdy.ai/api/search-image?query=Two%20balanced%20shopping%20baskets%20resting%20on%20a%20scale%20symbolizing%20comparing%20options%20and%20choices%20on%20a%20warm%20beige%20background%20minimal%20comparison%20concept%20editorial&width=1600&height=900&seq=article-alternatives&orientation=landscape",
  },
];